module.exports = __webpack_public_path__ + "media/images/official-3-6b2871e88e92a79e9fc0e8ed7024daa4.png";